module.exports = __webpack_public_path__ + "static/media/logo.d23cd5a2.png";